import { useSearchParams } from 'react-router'
import MuiCheckbox from '@mui/material/Checkbox'
import { FormControlLabel, type FormControlLabelProps } from './mui'
import { Typography } from '../Display'
import { Box } from '../Layout'

export interface CheckboxProps extends Omit<FormControlLabelProps, 'label' | 'name' | 'value' | 'control'> {
  title?: string
  id?: string
  filter?: {
    filterParam: string
    value: string
    title: string
  }
  checked?: boolean
}

export function Checkbox({
  title = '',
  id = undefined,
  filter = undefined,
  checked = undefined,
  ...props
}: CheckboxProps) {
  const [params] = useSearchParams()

  const checkboxId = id ?? `${filter?.filterParam}-${filter?.filterParam}`

  return (
    <FormControlLabel
      {...props}
      label={
        <Typography noWrap variant='smallBody1' sx={{ textTransform: 'capitalize' }}>
          {filter?.title ?? title}
        </Typography>
      }
      name={filter?.filterParam}
      value={filter?.value}
      control={
        <MuiCheckbox
          id={checkboxId}
          icon={<CheckboxIcon />}
          checkedIcon={<CheckboxIcon isChecked />}
          checked={filter ? params.getAll(filter.filterParam).includes(filter.value) : checked}
        />
      }
    />
  )
}

const CheckboxIcon = ({ isChecked = false }: { isChecked?: boolean }) => (
  <Box
    sx={{ height: 17, width: 17, mt: -0.25, border: 'n300', bgcolor: isChecked ? 'primary.main' : 'common.white' }}
  />
)
